import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "../slices/homeSlice";
import aboutUsSlice from "../slices/aboutUsSlice";
import contactUsSlice from "../slices/contactUsSlice";
import tourSlice from "../slices/tourSlice";
import hotelSlice from "../slices/hotelSlice";

export const makeStore = () => {
  return configureStore({
    reducer: {
      home: homeSlice,
      aboutUs: aboutUsSlice,
      contactUs: contactUsSlice,
      tour: tourSlice,
      hotel: hotelSlice,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
